module.exports = __webpack_public_path__ + "img/fauteuil-29.45ee52a5.jpg";